import { render, staticRenderFns } from "./StepPersonalDataComponent.vue?vue&type=template&id=a30a50dc&scoped=true&"
import script from "./StepPersonalDataComponent.vue?vue&type=script&lang=js&"
export * from "./StepPersonalDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepPersonalDataComponent.vue?vue&type=style&index=0&id=a30a50dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30a50dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCheckbox,VContainer,VFlex,VLayout,VTextField})
